/**
 * The message a jump lands on when its target is not shown: the closest shown message at or
 * before the target's position, else the first after it. Search finds text in messages the
 * transcript hides (tool-only steps, background or peer runs), and landing beside them beats
 * opening the chat at its end.
 */
export function nearestShownMessageId(
  shown: readonly { id: string; seq: number }[],
  seq: number,
): string | undefined {
  let before: { id: string; seq: number } | undefined;
  let after: { id: string; seq: number } | undefined;
  for (const message of shown) {
    if (message.seq <= seq) {
      if (!before || message.seq > before.seq) before = message;
    } else if (!after || message.seq < after.seq) {
      after = message;
    }
  }
  return (before ?? after)?.id;
}

/** Scrolls only the transcript so a row sits in the middle of it, or at the top if taller. */
export function centerRowInScroller(scroller: HTMLElement, row: Element) {
  const view = scroller.getBoundingClientRect();
  const box = row.getBoundingClientRect();
  const offset = box.top - view.top - Math.max(0, (scroller.clientHeight - box.height) / 2);
  scroller.scrollTop += offset;
}
